var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('a-field',{attrs:{"config":_vm.config.category},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }